/**
 * Endpoints REST liés aux documents (téléchargement, etc.).
 */
import { baseApi } from 'core/api/base'
import { IDocumentDownloadBase64Response } from 'core/interfaces/Document'
import { generatePath } from 'react-router'

const DOCUMENT_DOWNLOAD_BASE64_ENDPOINT =
  '/documents/:documentId/download-base64'

const documentApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getDocumentDownloadBase64: builder.query<
      IDocumentDownloadBase64Response,
      { documentId: number }
    >({
      query: ({ documentId }) =>
        generatePath(DOCUMENT_DOWNLOAD_BASE64_ENDPOINT, {
          documentId: documentId.toString(),
        }),
    }),
  }),
})

export const { useLazyGetDocumentDownloadBase64Query } = documentApi
export { documentApi }
